import { Dispatch, SetStateAction, memo, useEffect, useState } from 'react'
import Link from 'next/link'
import styles from './DownloadBanner.module.scss'
import Box from '@/components/UI/box/Box'
import Typography from '@/components/UI/typography/Typography'
import Icon from '@/components/UI/icon/Icon'
import { getOSName } from '@/helpers/props'
import useDevice from '@/hooks/useDevice'
interface DownloadBannerProps {
  setShowDownloadBanner?: Dispatch<SetStateAction<boolean>>
}

const DownloadBanner = ({ setShowDownloadBanner }: DownloadBannerProps) => {
  const [showBanner, setShowBanner] = useState(true)
  const { platform } = useDevice()
  useEffect(() => {
    if (
      showBanner &&
      (platform === 'iPhone' ||
        getOSName() !== 'web' ||
        sessionStorage.getItem('show-download-banner') === 'false')
    ) {
      setShowBanner(false)
    }
    if (!showBanner) {
      sessionStorage.setItem('show-download-banner', 'false')
      setShowDownloadBanner && setShowDownloadBanner(false)
    } else {
      setShowDownloadBanner && setShowDownloadBanner(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showBanner])

  if (!showBanner) return null

  return (
    <Box className={styles['container']}>
      <Typography variant={'bodyM'} color={'neutral_min'}>
        تخفیف های ویژه فقط در اپلیکیشن شب!
      </Typography>
      <Link className={styles['download-button']} href="/landing/app">
        <Typography variant={'bodyS'}>دانلود</Typography>
      </Link>
      <Icon
        className={styles['close-icon']}
        name={'close'}
        type={'white'}
        onClick={() => setShowBanner(false)}
      />
    </Box>
  )
}

export default memo(DownloadBanner)
